import axios, { AxiosError } from "axios";
import { env } from "@/config";
import { AssistedAffiliationDraftPayload } from "./types";

const assistedAffiliationDraftsEndpoint = "/v1/assisted-affiliation/draft";

export const buildAssistedAffiliationDraftPayload = (
  documentNumber: string
): AssistedAffiliationDraftPayload => ({
  document_number: documentNumber.trim(),
  document_type: "RNC",
  legal_name: "FERRETERIA XYZ SRL",
  commercial_name: "Ferretería XYZ",
  province_id: "01",
  province_name: "Distrito Nacional",
  municipality_id: "0101",
  municipality_name: "Santo Domingo de Guzman",
  sector_id: "010101",
  sector_name: "Naco",
  neighborhood_id: "01010101",
  neighborhood_name: "Ensanche Naco",
  street_and_number: "Calle Duarte #23",
  reference: "Frente al parque",
  commercial_category: "5251",
  detail_category: "Ferreteria",
  business_type: "FORMAL",
  average_sales: "500K_5M",
  rnc_certification: "s3://drafts/131234567/rnc_certification.pdf",
  commercial_register: "s3://drafts/131234567/commercial_register.pdf",
  representative_act: "s3://drafts/131234567/representative_act.pdf",
  bylaws: "s3://drafts/131234567/bylaws.pdf",
  pep_company: false,
  pep_representative: false,
  rep_representative: false,
  mcc_itbis: true,
  account_number: "1234567890",
  bank_account: "AHORRO",
  bank_id: "BHD",
  attachment: "s3://drafts/131234567/account_evidence.pdf",
  representative_phone: "+18095551234",
  representative_email: "juan.perez@example.com",
  representative_first_name: "Juan",
  representative_last_name: "Pérez",
  representative_is_foreign: false,
  representative_nationality: "DO",
  representative_country_code: "DO",
  product: {
    product_type: "SMARTPOS",
    amount: 1,
    price: 0,
    status: "ACTIVE",
  },
});

export const createDraftService = async (documentNumber: string) => {
  const payload = buildAssistedAffiliationDraftPayload(documentNumber);
  const response = await axios.post(
    `${env.MOCK_API_URL}${assistedAffiliationDraftsEndpoint}`,
    payload,
    {
      headers: { "Content-Type": "application/json" },
    }
  );

  return response.data;
};

const MAX_SERVER_MESSAGE_LENGTH = 200;

// El servidor puede responder una página HTML cuando la ruta no existe: mostrarla cruda no le dice nada al
// usuario, así que el body solo se acepta cuando parece una frase.
const isReadableMessage = (value: string) => {
  const trimmed = value.trim();
  return (
    trimmed.length > 0 &&
    trimmed.length <= MAX_SERVER_MESSAGE_LENGTH &&
    !trimmed.startsWith("<")
  );
};

export const getDraftErrorMessage = (
  error: unknown,
  fallback = "No se pudo crear el comercio."
) => {
  const axiosError = error as AxiosError<{ message?: string; error?: string } | string>;
  const responseData = axiosError.response?.data;

  if (typeof responseData === "string") {
    return isReadableMessage(responseData) ? responseData : fallback;
  }

  return responseData?.message || responseData?.error || fallback;
};
